import React from "react";
import { Link } from "react-router-dom";

function Services() {
  const servicesData = [
    {
      title: "Electrical Design and Consultation",
      icon: "bi bi-lightning-charge",
      description:
        "We provide complete electrical design and consultation services to ensure safe, efficient, and cost-effective systems for residential, commercial, and industrial projects.",
      features: [
        "Load Calculation & Distribution",
        "Lighting & Power System Design",
        "Energy Efficiency Consulting",
      ],
      link: "/service-details/strategic-planning",
      delay: 200,
    },
    {
      title: "Automation and Control Systems",
      icon: "bi bi-cpu",
      description:
        "We design and implement automation and control systems that improve productivity, ensure safety, and reduce operational costs.",
      features: [
        "PLC & SCADA System Design",
        "Industrial Automation",
        "Process Monitoring & Control",
      ],
      link: "/service-details/business-transformation",
      delay: 300,
    },
    {
      title: "Maintenance and Support",
      icon: "bi bi-tools",
      description:
        "We provide reliable maintenance and technical support services to ensure smooth operation and minimize downtime of your systems.",
      features: [
        "Preventive Maintenance",
        "24/7 Technical Support",
        "System Troubleshooting & Repairs",
      ],
      link: "/service-details/financial-advisory",
      delay: 400,
    },
    {
      title: "Project Management",
      icon: "bi bi-kanban",
      description:
        "Our project management services ensure that your projects are delivered on time, within budget, and to the highest quality standards.",
      features: [
        "Planning & Scheduling",
        "Resource Allocation",
        "Risk & Quality Management",
      ],
      link: "/service-details/human-resources",
      delay: 500,
    },
    {
      title: "HVAC System Design and Implementation",
      icon: "bi bi-wind",
      description:
        "We provide professional HVAC solutions to ensure efficient indoor air quality, comfort, and energy savings.",
      features: [
        "HVAC Load Analysis & System Design",
        "Energy-Efficient Solutions",
        "Installation & Commissioning",
      ],
      link: "/service-details/hvac-design",
      delay: 600,
    },
    {
      title: "Renewable Energy Solutions",
      icon: "bi bi-sun",
      description:
        "We deliver sustainable renewable energy solutions to reduce costs and environmental impact.",
      features: [
        "Solar Power System Design",
        "Energy Storage Solutions",
        "Hybrid & Grid Integration",
      ],
      link: "/service-details/renewable-energy",
      delay: 700,
    },
  ];

  return (
    <section id="services" className="services section mb-0">
      <div className="container section-title" data-aos="fade-up">
        <h2>Services</h2>
        <div>
          <span>Check Our</span>
          <span className="description-title"> Services</span>
        </div>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row gy-4">
          {servicesData.map((service, index) => (
            <div
              key={index}
              className="col-lg-4 col-md-6"
              data-aos="fade-up"
              data-aos-delay={service.delay}
            >
              <div className="service-card">
                <div className="icon-box">
                  <i className={service.icon}></i>
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <ul className="service-features">
                  {service.features.map((feature, i) => (
                    <li key={i}>
                      <i className="bi bi-check-circle"></i> {feature}
                    </li>
                  ))}
                </ul>
                <a href="#contact" className="read-more">
                  Learn More <i className="bi bi-arrow-right"></i>
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* <div className="text-center mt-5" data-aos="fade-up" data-aos-delay="800">
          <a href="#contact" className="btn btn-primary">
            Request a Consultation
          </a>
        </div> */}
      </div>
    </section>
  );
}

export default Services;
